const zIndex = {
  appHeader: 1050,
};

export default zIndex;
